import styled from 'styled-components'

export const Container = styled.div`
  max-width: 1423px;
  padding: 0 10px;
  width: 100%;
  margin: 0 auto;
  @media (max-width: 1250px) {
    padding:0 15px;
  }
  .MuiAppBar-colorPrimary {
    background-color: transparent;
    box-shadow: none;
    padding-bottom: 25px;
  }
  .MuiTab-textColorInherit.Mui-selected {
    color: #0a1f30;
    font-family: "latobold" !important;
  }
  .MuiTab-textColorInherit {
    color: #7a7a7a;
    opacity: 1;
    text-transform: capitalize;
    font-size: 16px;
    font-family: "latomedium" !important;
  }
  .MuiTabs-indicator {
    background-color: #2fb5f1;
    height: 4px;
  }
  .MuiBox-root {
    padding: 0;
  }
  .MuiTab-wrapper{
    flex-direction: row;
    gap: 8px;
    align-items: center;
  }
  .MuiIconButton-edgeEnd{
    margin-right: -12px !important;
  }
  .notification {
    color: #ffffff;
    background-color: #3fb144;
    padding: 2px;
    border-radius: 50%;
    height: 24px;
    min-width: 24px;
    top: 44px;
    right: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }
`;

export const SearchSection = styled.div`
  max-width: 650px;
  width: 55vw;
  border-radius: 3px;
  padding: 2px 15px;
  position: relative;
  margin-left: 10px;

  .type-ahead-search-input {
    > div input {
      border-radius: 23px;
      box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
      border: solid 1px #fff;
      background-color: #fff;
      height: 40px;
    }
    .dropdown-menu {
      display: none !important;
    }
    .dropdown-menu .dropdown-item {
      padding: 10px 16px;
      font-size: 14px;
    }
    .seacrh-icon {
      border-radius: 0 3px 3px 0;
      margin: 0;
      height: 35px;
      position: absolute;
      cursor: pointer;
      right: 5px;
      padding: 9px;
    }
  }
`;
export const OrderTopHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e1e1e1;
  > div {
    .custom-select__control {
      border-radius: 23px;
      box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
      border: solid 1px #fff;
      background-color: #fff;
      height: 40px;
    }
    :first-child {
      width: 225px;
    }
    :nth-child(2) {
      padding: 0;
    }
  }
`;
export const SectionWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-column-gap: 46px;
  margin-top: 10px;

  @media (max-width: 1250px) {
    grid-template-columns: 1fr;
    .pd-right-nav {
      display: none;
    }
  }
  @media (max-width: 767px) {
    display: flex;
    flex-direction: column-reverse;
    gap: 0px;
  }
`;
export const OrderTabDescription = styled.div`
  position: relative;
  img.right-arrow {
    position: absolute;
    left: -16px;
    top: 5px;
    height: 39px;
    width: 53px;
  }
  .pallete-image.borderLightBlue{
    border: 1px solid #87cdf1 !important;
  }
  .pallete-image.borderDarkBlue{
    border: 1px solid #0a5587 !important;
  }
  .MuiTabs-flexContainer{
    justify-content: space-between !important;
  }
`;
export const FilterWrapper = styled.div`
  margin-left: 10px;
  box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
  padding: 5px;
  border-radius: 10px;
  img {
    cursor: pointer;
  }
`;

export const DelReqContentWrapper = styled.div`
  .pending-tab-content-mobile-view-wrapper{
    border-radius: 5px;
    padding: 15px 10px;
    h6{
      font-size: 15px;
      font-family: 'latobold';
    }
    hr{
      margin: 0px;
    }
    .outer-wrapper{
      padding: 0 15px;
    }
    .row-class{
      display: flex;
      justify-content: space-between;
    }
    .elements-class{
      min-width: 130px;
      margin-bottom: 5px;
      p{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 125px;
      }
    }
    .button-wrapper{
      display: flex;
      gap: 15px;
      margin-top: 15px;
      justify-content: end;
      margin-right: 10px;
      font-size: 12px;
      button{
        border: none;
        border-radius: 5px;
        padding: 0 15px;
        height: 36px;
        cursor: pointer;
        color: #fff;
        background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
        width: 100px;
      }
    }
  }
  .pending-tab-content-web-view-wrapper{
    display: flex;
    gap: 10px;
    justify-content: space-between;
    padding: 0 12px;
    background: #FFFFFF;
    align-items: center;
    width: 100%;
    font-size: 17px;
    height: 38px;
    p{
      flex: 1;
    }
    .loc-name-style{
      color: rgb(10, 85, 135);
      font-family: latobold;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 310px;
      flex: 1.5;
    }
    .button-wrapper{
      display: flex;
      gap: 15px;
      font-size: 12px;
      button{
        border: none;
        border-radius: 5px;
        padding: 0 15px;
        height: 36px;
        cursor: pointer;
        color: #fff;
        background: linear-gradient(180deg, #0A5587 0%, #12659D 100%);
        width: 100px;
      }
    }
  }
  .accordion-details-style{
    width: 100%;
    margin-top: -15px;
    .div-wrapper{
      display: flex;
      margin: 15px 0;
      font-size: 17px;
      gap: 20px;
      p{
        font-family: "latobold";
        width: 30%;
        margin: 0;
        margin-left: 15px;
      }
    }
  }
  .pending-tab-content-mobile-view{
    display: none;
  }
  .pending-tab-content-web-view{
    /* display: flex; */
  }
  @media (max-width: 500px) {
    .pending-tab-content-web-view{
      display: none;
    }
    .pending-tab-content-mobile-view{
      display: block;
    }
  }
`